module.exports = __webpack_public_path__ + "img/category_664.70d960d8.jpg";